// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "toastNotification" + ".mp." + "eb4c75ac" + ".css";
};